module.exports = __webpack_public_path__ + "static/media/dolly-flatbed.723c78cd.svg";